import React, { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

// reCAPTCHA Site Key - Replace with your actual site key in production
// For testing, use Google's test keys
const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

/**
 * Reusable reCAPTCHA component wrapper
 * 
 * Usage:
 * const recaptchaRef = useRef(null);
 * 
 * // Get token when form submits
 * const token = recaptchaRef.current?.getValue();
 * 
 * // Reset after submission
 * recaptchaRef.current?.reset();
 */
const CaptchaWidget = forwardRef(({ 
  onChange, 
  onExpired,
  theme = 'light',
  size = 'normal',
  className = ''
}, ref) => {
  
  const handleChange = (token) => {
    if (onChange) {
      onChange(token);
    }
  };

  const handleExpired = () => {
    if (onExpired) {
      onExpired();
    }
  };

  return (
    <div className={`captcha-widget ${className}`} data-testid="recaptcha-widget">
      <ReCAPTCHA
        ref={ref}
        sitekey={RECAPTCHA_SITE_KEY}
        onChange={handleChange}
        onExpired={handleExpired}
        theme={theme}
        size={size}
      />
    </div>
  );
});

CaptchaWidget.displayName = 'CaptchaWidget';

export default CaptchaWidget;

// Export the site key for backend verification reference
export const SITE_KEY = RECAPTCHA_SITE_KEY;
